<template>
  <div>
    <div>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>도급분야 위험성평가 실시</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8">
        <vs-col>
          <p class="semi-bold-text">· 급인과 수급인이 각각 위험성평가를 실시하여야함</p>
          <p class="semi-bold-text">· 최초 평가 이후 매년 정기적으로 재검토 하여 현행화</p>
          <p class="semi-bold-text">· 산업재해 발생, 설비의 변경·도입 등을 했을 시 수시 위험성평가</p>
        </vs-col>
      </vs-row>

      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>합동 안전·보건점검</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8">
        <vs-col>
          <p class="semi-bold-text">· 도급 사업시 도급인 및 관계수급인은 합동으로 수행중인 작업에 대해 안전보건조치의 적정성 여부를 점검 및 조치하여야 한다.</p>
          <p class="semi-bold-text">· (구성)  ①도급인  ②관계수급인 ③ 도급인 및 관계수급인 근로자 각 1명</p>
          <p class="normal-text ml-4">* 도급인 및 관계수급인 사업주(같은 사업내에 지역을 달리하는 사업장이 있는 경우 그 사업장의 안전보건관리책임자), 도급인 및 관계수급인 근로자(관계수급인의 근로자는 해당공정 근로자만 해당-수급인이 다수인 경우 각 수급인 소속 근로자 1명 씩 점검에 참여하되, 해당공정에 참여)</p>
          <p class="semi-bold-text">· 분기 1회 이상(건설은 2개월 1회)</p>
        </vs-col>
      </vs-row>

      <vs-row class="mb-8" style="border:1px solid #cdcdcd;">
        <vs-col>
          <ul class="table table-1" style="border-bottom:none;">
            <li class="justify-start" style="background-color: #fafafa">
              <div>
                <span class="px-4 bold-text">관련법령</span>
              </div>
            </li>
            <li class="justify-start p-4 text-left">
              <div>
                <p class="semi-bold-text">· 산업안전보건법 제36조(위험성평가의 실시)</p>
                <p class="normal-text ml-4">① 사업주는 건설물, 기계ㆍ기구ㆍ설비, 원재료, 가스, 증기, 분진, 근로자의 작업행동 또는 그 밖의    업무로 인한 유해ㆍ위험 요인을 찾아내어 ~ 평가하여야 하고, 그 결과에 따라 이 법과 이 법에     따른 명령에 따른 조치를 하여야 하며, ~필요한 경우에는 추가적인 조치를 하여야 한다.</p>
                <p class="normal-text ml-4">④ 제1항에 따른 <span style="color: #FF8510">평가의 방법, 절차 및 시기, 그 밖에 필요한 사항은 고용노동부장관이 정하여 고시</span></p>
                <p class="semi-bold-text">산업안전보건법 시행규칙 제37조(위험성평가 실시내용 및 결과의 기록‧보존)</p>
                <p class="semi-bold-text">사업장 위험성평가에 관한 지침(2023.4. 개정예고)</p>
              </div>
            </li>
            <li class="justify-start">
              <ul class="table table-2">
                <li style="border: none;">
                  <div style="background-color: #fafafa; height: 100%; align-content: center; border-right: 1px solid #cdcdcd; max-width: 100px;">
                    <span class="bold-text">고시</span>
                  </div>
                  <div>
                    <span class="bold-text">위험성평가의 실시 주체</span>
                  </div>
                </li>
              </ul>
            </li>
            <li class="justify-start p-4 text-left">
              <div>
                <p class="semi-bold-text">· 제5조(위험성평가 실시주체)</p>
                <p class="normal-text ml-4">① 사업주는 스스로 사업장의 유해ㆍ위험요인을 파악하고 이를 평가하여 관리 개선하는 등 위험성평가를 실시하여야 한다.</p>
                <p class="normal-text ml-4" style="color: #FF8510">② 법 제63조에 따른 작업의 일부 또는 전부를 도급에 의하여 행하는 사업의 경우는 도급을 준 도급인(이하 “도급사업주”라 한다)과 도급을 받은 수급인(이하 “수급사업주”라 한다)은 각각 제1항에 따른 위험성평가를 실시하여야 한다.</p>
                <p class="normal-text ml-4">③ 제2항에 따른 도급사업주는 수급사업주가 실시한 위험성평가 결과를 검토하여 도급사업주가 개선할 사항이 있는 경우 이를 개선하여야 한다.</p>
              </div>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  components: {
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
}
</script>

<style scoped>
.bold-text {
  font-weight: 700;
  font-size: 16px;
}
.semi-bold-text {
  font-weight: 500;
  font-size: 14px;
}

.normal-text {
  font-weight: 400;
}
</style>
